<template>
    <div class="component component__labelsample">
        <div class="columns is-vcentered">
            <div class="column is-narrow">
                <div class="component__labelsample_label">
                    {{ label }}<span class="asterisk" v-if="required">*</span>
                </div>
            </div>
            <div class="column is-narrow">
                <div class="component__labelsample_sample">{{ sample }}</div>
            </div>
            <div class="column"></div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'component-labelsample',
  props: {
    label: {
      type: String
    },
    required: {
      type: Boolean
    },
    sample: {
      type: String
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentlabelsample";
</style>
